import Cookies from 'js-cookie';

// import mixpanel from "mixpanel-browser";

export const trackCheckoutEvent = (action, properties = {}) => {
  const { loggedInUserID } = Window.user_data;
  const orderData = Cookies.get('plus_order_data');

  const baseTrackingData = {
    user_id: loggedInUserID,
    category: 'dfr',
    order_data: orderData ? JSON.parse(orderData) : {}
  };

  mixpanel.track(`plus_checkout:${action}`, {
    ...baseTrackingData,
    ...properties
  });
};
